import DateTime from '@dealroadshow/uikit-date-time';

const currentYear = new DateTime().getFullYear();

const MONTH_NAMES_SHORT = Array.from({ length: 12 }, (_, i) => new DateTime(new Date(currentYear, i)).format('MMM'));
const MONTH_NAMES_FULL = Array.from({ length: 12 }, (_, i) => new DateTime(new Date(currentYear, i)).format('MMMM'));

const OverlayView = { None: 'none', Month: 'month', Year: 'year' } as const;
type TOverlayView = typeof OverlayView[keyof typeof OverlayView];

export { MONTH_NAMES_SHORT, MONTH_NAMES_FULL, OverlayView, type TOverlayView };
